export const makansafeConstants = {
    GENERATE_AI_IDDSI_FOOD_REQUEST: 'GENERATE_AI_IDDSI_FOOD_REQUEST',
    GENERATE_AI_IDDSI_FOOD_SUCCESS: 'GENERATE_AI_IDDSI_FOOD_SUCCESS',
    GENERATE_AI_IDDSI_FOOD_FAILURE: 'GENERATE_AI_IDDSI_FOOD_FAILURE'
};